import modelValidatorCreator from '../../../validators/model-validator-creator';

const quarantineModel = modelValidatorCreator.createModelWithValidation({
    reason: {
        value: null,
        required: true
    }
});

export default quarantineModel;
